import {ref} from 'vue'

const tscroll = ref(0)
export default tscroll 
export { tscroll } 